import React from 'react'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'

import keyfeaturebox from '../../../assets/images/medilearn/keyfeaturebox.svg'
import bg from '../../../assets/images/medilearn/bg.svg'

const features = [
  {
    title: 'AI Symptom Checker',
    desc: 'Real-time, guided health conversations',
  },
  {
    title: 'Medical Categories',
    desc: 'Explore domains like Neurology, Dentistry, Orthopedics',
  },
  {
    title: 'Conversational UI',
    desc: 'Human-like interaction for better clarity',
  },
  {
    title: 'Smart Suggestions',
    desc: 'Context-aware responses for faster insights',
  },
  {
    title: 'Minimal Experience',
    desc: 'Designed for focus, clarity, and ease of use',
  },
]

const positions = [
  'mr-auto',
  'ml-auto',
  'mr-auto',
  'ml-auto',
  'mr-auto',
]

const KeyFeatureSection = () => {
  return (
    <section className="relative overflow-hidden bg-[#9BB069] py-6 md:py-10">
      {/* CENTER BACKGROUND */}
      <img
        src={bg}
        alt=""
        className="
          pointer-events-none
          absolute
          inset-0
          z-0
          m-auto
          h-full
          w-full
          object-container
          object-center
          opacity-20
        "
      />

      {/* Heading */}
      <motion.div
        initial={{ opacity: 0, scale: 0.7 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.7, ease: 'easeOut' }}
        viewport={{ once: false }}
        className="mb-16 flex justify-center"
      >
        <div className="relative top-[30px] flex items-center gap-2 bg-[#9BB069] px-8 md:gap-5">
          <div className="h-1.5 w-1.5 rounded-full bg-white md:h-3 md:w-3" />

          <h2 className="font-gilroy-extrabold text-xl uppercase text-black md:text-3xl 2xl:text-5xl">
            Key Features
          </h2>

          <div className="h-1.5 w-1.5 rounded-full bg-white md:h-3 md:w-3" />
        </div>
      </motion.div>

      <div
        className="
          relative
          mx-auto
          min-h-[500px]
          w-[90%]
          max-w-[1400px]
          md:min-h-[750px]
          md:w-[75%]
          lg:min-h-[700px]
          xl:min-h-[800px]
          2xl:min-h-[1000px]
        "
      >
        {features.map((item, index) => (
          <motion.div
            key={index}
            initial={{
              opacity: 0,
              x: index % 2 === 0 ? -150 : 150,
            }}
            whileInView={{
              opacity: 1,
              x: 0,
            }}
            transition={{
              duration: 0.8,
              ease: 'easeOut',
              delay: index * 0.15,
            }}
            viewport={{ once: false }}
            className="relative mb-4 md:mb-8"
          >
            {/* Connector */}
            {/* {index !== features.length - 1 && (
              <img
                src={keyfeaturebox}
                alt=""
                className={`
                  pointer-events-none
                  absolute
                  top-[52%]
                  z-10
                  hidden
                  md:block

                  ${
                    index % 2 === 0
                      ? 'left-[42%]'
                      : 'right-[22%] scale-x-[-1]'
                  }

                  w-[45%]
                  xl:h-[205px]
                  xl:w-[2000px]

                  opacity-80
                `}
              />
            )} */}

            {/* Card */}
            <div
              className={`
                relative
                z-20

                ${positions[index]}

                w-full
                md:w-[80%]
                xl:w-[52%]

                border
                border-white/30

                bg-[#c5d39b]/30
                px-4
                py-2

                backdrop-blur-md

                md:px-5
                md:py-5

                lg:px-8

                xl:px-10
                xl:py-7
              `}
            >
              <h3 className="md:mb-2 font-gilroy-bold text-base text-white md:text-xl xl:text-2xl 2xl:text-3xl">
                {item.title}
              </h3>

              <div className="flex items-start gap-2">
                <ArrowRight
                  className="
                    mt-[4px]
                    h-[14px]
                    w-[14px]
                    shrink-0
                    text-white

                    md:h-[18px]
                    md:w-[18px]

                    xl:h-[24px]
                    xl:w-[24px]

                    2xl:h-[30px]
                    2xl:w-[30px]
                  "
                />

                <p className="text-sm leading-[1.7] text-white/90 md:text-base xl:text-xl 2xl:text-2xl">
                  {item.desc}
                </p>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}

export default KeyFeatureSection